export const DropArrowIcon = ({ mainClassName, fillClassName }) => (
    <svg className={mainClassName} width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className={fillClassName} d="M6.02918 0H0.97082C0.524791 0 0.234694 0.469388 0.434164 0.868329L2.96334 5.92669C3.18446 6.36892 3.81554 6.36892 4.03666 5.92669L6.56584 0.868328C6.76531 0.469387 6.47521 0 6.02918 0Z" fill="black" />
    </svg>
)